import React from "react";
import MusicModule from "@/components/app/MusicModule";

export default function Musica() {
  return (
    <div className="max-w-4xl mx-auto" data-testid="musica-page">
      <div className="mb-5">
        <p className="text-[11px] uppercase tracking-[0.25em] text-nardo-500">Multimedia</p>
        <h1 className="font-display font-bold text-2xl sm:text-3xl text-navy">Música</h1>
        <p className="text-sm text-nardo-500 mt-1">Abre Spotify o YouTube en su propia ventana, o usa tu biblioteca guardada y compartida del colegio.</p>
      </div>
      <MusicModule />
    </div>
  );
}
